import { css } from '@emotion/react';

import { colors } from '../../../../styles/colors';
import { ZeeFontRegular } from '../../../../styles/font';

export const popupMetaDetails = (overout: boolean, type?: string) => css`
  display: flex;
  ${!overout || type
    ? `color: ${colors.AccentInfoPopupDescriptionMobileColor};
  ${ZeeFontRegular(9, 18)}`
    : `${ZeeFontRegular(16)}
  color:${colors.Transparent};
  margin-top:10px;
  `}

  & span {
    position: relative;
    :not(:first-of-type) {
      padding-left: 20px;
      :before {
        content: '';
        position: absolute;
        height: 5px;
        width: 5px;
        border-radius: 20px;
        background-color: ${colors.AccentInfoPopupDescriptionMobileColor};
        left: 10px;
        top: ${type ? '7px' : '5px'};
      }
    }
  }
`;
